import GnbExtraBtn from './GnbExtraBtnContainer';

export default GnbExtraBtn;
